import List from './List'
import Overview from './Overview'

export const tabs = [
    {
        label: 'overview',
        value: 'overview',
        component: <Overview />,
    },
    {
        label: 'contract-list',
        value: 'list',
        component: <List />,
    },
]
